<div wnlGroup #wnlGroup="wnlGroup">
  <div class="wnl-header">
    <p>WNL: Skin warm, clean, dry and intact. Pink mucus membranes.</p>
    <mat-checkbox [checked]="wnlGroup.allWnl" [indeterminate]="wnlGroup.someWnl"
      (change)="wnlGroup.setAllWnl($event.checked)"
      [ngClass]="{'wnl-checked': wnlGroup.allWnl && !wnlGroup.someWnl, 'wnl-indeterminate': wnlGroup.someWnl}">
      All Within Normal Limits
    </mat-checkbox>
  </div>

  <div [formGroup]="formGroup()" class="form-container">
  <assessment-row title="Skin Appearance">
    @if (patient().isPediatric()) {
      <emr-checkbox-group [control]="formGroup().controls.skinAppearance" [options]="skinAppearanceOptionsPediatric"
        [wnlControl]="'skinAppearance'" [wnlDefault]="[]" [wnlClearValue]="null" />
    } @else {
      <emr-checkbox-group [control]="formGroup().controls.skinAppearance" [options]="skinAppearanceOptions"
        [wnlControl]="'skinAppearance'" [wnlDefault]="[]" [wnlClearValue]="null" />
    }
    @if (needCommentBox){
    <emr-input type="text" label="Comments" [control]="formGroup().controls.skinAppearanceComment" />
    }
  </assessment-row>

  <h2>Wounds</h2>

  <assessment-row title="Location">
    <emr-input type="text" width="50%" [control]="formGroup().controls.location"
      [wnlControl]="'location'" [wnlDefault]="''" [wnlClearValue]="null" />
  </assessment-row>

  <assessment-row title="Staging">
    <emr-input type="select" [control]="formGroup().controls.staging" [options]="stagingOptions"
      [wnlControl]="'staging'" [wnlDefault]="''" />
  </assessment-row>

  <assessment-row title="Wound Care">
    <emr-checkbox-group [control]="formGroup().controls.care" [options]="careOptions"
      [wnlControl]="'care'" [wnlDefault]="[]" [wnlClearValue]="null" />
  </assessment-row>

  <assessment-row title="Other Findings">
    <emr-input type="text" [control]="formGroup().controls.otherFindings" [wnlControl]="'otherFindings'"
      [wnlDefault]="''" [wnlClearValue]="null" />
  </assessment-row>
</div>
</div>